export const ErrorSpinnerPageStyle = {
  baseStyle: {},
  variants: {
    wrapper: {
      logo: {
        p: '4px',
        bg: '#29292A',
        h: '100px',
        display: 'flex',
        alignContent: 'center',
        grid: {
          gap: 4,
          gridItem: {
            display: 'flex',
            justifyContent: 'center',
            p: '10px',
            img: {
              height: '70px',
            },
          },
        },
      },
      error: {
        p: 10,
        header: {
          pl: 5,
          pb: 5,
        },
        content: {
          padding: 5,
          minH: 500,
          mb: 10,
          border: '1px',
          borderColor: 'GRAY',
          borderRadius: '4px',
        },
      },
    },
  },
};
